<!--
 * @Author: cn1994
 * @Date: 2024-09-24 13:27:40
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-15 16:01:31
 * @Description: 按钮组件
-->
<template>
  <div class="ls-ui-tag" :class="`ls-ui-tag-${type}`">
    <slot></slot>
  </div>
</template>

<script>

import mixin from './index.js'

export default {
  name: 'LsTag',
  componentName: 'LsTag',
  mixins: [mixin],
  props: {
    type: {
      type: String,
      default: 'primary',
      validator: (val) => ['primary', 'success', 'warning', 'danger','doing','done','not_start','yellow'].includes(val),
    },
  },
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>